import classes from './loginPopup.scss';
import FocusTrap from 'focus-trap-react';
import Modal from 'react-awesome-modal';
import SceButton from '../../../Common/CommonComponents/sceButton';
import OktaLogin from '../../../../src/Login/OktaLogin/OktaLogin';

const LoginPopup = (props) => {
     function handleCloseButtonClick() {
        app.appService.removeSessionStorageItem(app.appService.appConstants.isPwdChanged);
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.LOGOUT);
    }
    
   function handleResetPasswordClick() {
        app.appService.removeSessionStorageItem(app.appService.appConstants.isPwdChanged);
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.RESET_PASSWORD);
    }
     
    return (
        <FocusTrap>
          <div tabindex="0">
            <Modal visible='true'
            effect='fadeInUp'
            >  
                    <div id='resetPassword-cancel-button' className={classes.sceBtn}>
                        <SceButton
                            buttonType='sceSmCancel'
                            iconColor='iconNeutralBlack'
                            value={''}
                            iconPosition='right'
                            iconType='cancel'
                            onClick={handleCloseButtonClick} 
                        />      
                    </div>    
                <OktaLogin inlineWidget />
            </Modal> 
   </div>
        </FocusTrap>
    );
};

export default LoginPopup;
